import * as React from 'react';
import {
  Container,
  Box,
  ListItemText,
  ListSubheader,
  List,
  ListItemButton,
  Typography,
  Button
} from '@mui/material';
import useStore from '../state-files/zustondStoreStates';
import { apiUrlPrefix } from '../../../config';
import HeaderBar from '../Components/Static/HeaderBar';
import { Link, useNavigate } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import { ListItem } from 'semantic-ui-react';
import Sidebar from '../Components/Sidebar/Sidebar';
import MobileSidebar from '../Components/Sidebar/MobileSidebar';
import fetchBannedUsers from '../helper-methods/fetchBannedUsers';

const BannedUsers = () => {
  const [reports, setReports] = React.useState([]);
  const { setDiscussionPressed } = useStore();
  const [setBannedUsers] = React.useState([]);
  const { greenButtonSX } = useStore();
  const navigate = useNavigate();

  React.useEffect(() => {
    setReports([]);
    fetchBannedUsers(setReports);
    setDiscussionPressed(false);

  }, []);

  const unbanUser = async (userId) => {
    const apiUrl = apiUrlPrefix + 'Report/UnbanUser';
    const response = await fetch(apiUrl, {
      method: 'POST',
      credentials: 'include', // Include cookies in request
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Id: userId,
        isBanned: false
      }),
    });
    if (response.ok) {
      return response.status;
    } else if (response.status === 400) {
      return 304; //It is not modified
    }
  }

  const completeAction = async (reportId) => {
    const apiUrl = apiUrlPrefix + 'Report/CompleteReport';
    const response = await fetch(apiUrl, {
      method: 'POST',
      credentials: 'include', // Include cookies in request
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Id: reportId,
      }),
    });
    if (response.ok) {
      return response.status;
    }
  }

  React.useEffect(() => {
    // Call the async function and wait for the result
    login().then((isAdmin) => {
      if (!isAdmin) {
        navigate('/discussions', { replace: true });
      }
    });
  }, []);

  const login = async () => {
    const isAdmin = await fetchBannedUsers(setReports);
    return isAdmin;
  }

  const sortedReports = Array.isArray(reports)
    ? [...reports].sort((a, b) => b.id - a.id)
    : [];

  return (
    <Box
      sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <HeaderBar isLoggedIn={true} />
      <Box sx={{ display: 'flex', gap: 3, justifyContent: 'flex-start' }}>
        <Sidebar />
        <MobileSidebar />

        <Container>
          <List
            sx={{ width: '100%', bgcolor: 'background.paper', borderRadius: '5px', boxShadow: 1 }}
            component="nav"
            subheader={
              <ListSubheader
                component="div"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  py: 1,
                  borderBottom: '1px solid #eee'
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Banned Users
                </Typography>
                <p />

                {/* Create Discussion button */}
                <Typography component={Link} to="/adminPanel" variant="subtitle1" sx={greenButtonSX}>
                  <Button>Admin Panel</Button>
                </Typography>


                {/* Place the actual widget here so it can listen for the state change */}

              </ListSubheader>
            }
          >
            {sortedReports?.map((report, index) => {
              const feedbackType = report.reportType;
              return (
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', gap: 3, paddingLeft: 2 }}>
                  <ListItem key={report.id} sx={{
                    alignItems: 'flex-start', textAlign: 'left', display: 'flex', flexDirection: 'column',
                    flexGrow: 1
                  }}>
                    {feedbackType === 'Message' ? (<>
                      <ListItemText
                        primary={"Report ID: " + report.id || "Unknown"}
                        sx={{ textAlign: 'left' }}
                      />
                      <ListItemText
                        primary={"Report type: " + report.reportType || "Unknown"}
                        sx={{ textAlign: 'left' }}
                      />
                      <ListItemText
                        sx={{ display: report.communityName !== 'null' ? 'none' : 'flex' }} primary={"Community ID: " + report.communityName || "Unknown"}
                      />
                      <ListItemText
                        primary={"Discussion ID: " + report.discussionName || "Unknown"}
                        sx={{ textAlign: 'left' }}
                      />
                      <ListItemText
                        primary={"Reporter ID: " + report.name || "Unknown"}
                        sx={{ textAlign: 'left' }}
                      />
                      <ListItemText
                        primary={"Reported user: " + report.reportedUsername || "Unknown"}
                        sx={{ textAlign: 'left' }}
                      />
                      <ListItemText
                        primary={"Reported message: " + report.reportedMessage || "Unknown"}
                        sx={{ textAlign: 'left' }}
                      />
                    </>)
                      :
                      (<>
                        <ListItemText
                          primary={"User: " + report.name || "Unknown"}
                          sx={{ textAlign: 'left' }}
                        />
                      </>)}
                  </ListItem>

                  <Typography sx={{ display: 'flex', color: 'blue', cursor: 'pointer' }} onClick={() => {
                    completeAction(report.id);
                    const newReportList = reports.filter((reports) => reports.id !== report.id);
                    setReports(newReportList);
                  }}><CheckIcon /></Typography>
                  <Typography sx={{ display: 'flex', color: 'green', pr: 3, cursor: 'pointer' }} onClick={() => {
                    unbanUser(report.id);
                    setBannedUsers((prev) => ({ ...prev, [report.reportedUsername]: true }));

                    //Complete the report
                    completeAction(report.id);
                    const newReportList = reports.filter((reports) => reports.id !== report.id);
                    setReports(newReportList);

                  }}>Unban user</Typography>
                </Box>
              )
            })}
          </List>
        </Container>
      </Box>
    </Box>
  );
};

export default BannedUsers;